import SelectMulti from "components/SelectMulti/selectmulti.component";
import Title from "components/Title/title.component";
import { PRESTACAO_CONTAS_PERMISSIONS } from "constants/index";
import { saveAs } from "file-saver";
import { Form, Formik } from "formik";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import downloadService from "services/downloadService";
import Button from "../../../components/Button/button.component";
import Required from "../../../components/Required/required.component";
import Subtitle from "../../../components/Subtitle/subtitle.component";
import Table from "../../../components/Table/table.component";
import FileHelper from "../../../utils/fileHelpers";

class AnalisePrestacao extends Component {
	columnsDocumentos = [
		{ id: 0, title: "Nome", property: "nome" },
		{ id: 1, title: "Tipo", property: "tipoDocumento.property" }
	];

	tiposDocumento = [
		{ id: 2, property: "Atestado", nome: "atestado" },
		{ id: 3, property: "Certidão", nome: "certidao" },
		{ id: 4, property: "Outro", nome: "outro" }
	];

	actionsDocumentos = [
		{
			name: "Download",
			icon: "fas fa-download",
			action: item => this.props.downloadFile(item)
		},
		{
			name: "Excluir",
			icon: "fas fa-trash-alt",
			action: item => this.props.removeUpload(item)
		}
	];

	downloadModelo = async tipoDocumento => {
		const { data: arquivo } = await downloadService.downloadTemplate(
			tipoDocumento
		);
		const fileSignature = FileHelper.buf2hex(arquivo);
		const fileMimeType = FileHelper.getMimetype(fileSignature.slice(0, 8));

		const blob = new Blob([arquivo], { type: fileMimeType });
		saveAs(blob, `${tipoDocumento}.doc`);
	};

	modeloAtestado() {
		const { hasAtestado } = this.props;
		return (
			<button
				type="button"
				className="btn btn-link"
				onClick={() =>
					this.downloadModelo(
						"Modelo_do_atestado_de_servidor_publico_do_executivo_municipal"
					)
				}
			>
				<div className="mr-2 mb-3 fas fa-download fa-xs" />
				Atestado de Servidor Público do Executivo Municipal
				{hasAtestado ? (
					<div className="ml-2 fas fa-check-circle text-success" />
				) : null}
			</button>
		);
	}

	modeloCertidao() {
		const { hasCertidao } = this.props;
		return (
			<button
				type="button"
				className="btn btn-link"
				onClick={() =>
					this.downloadModelo(
						"Modelo_da_certidao_de_entrega_de_ajuda_humanitaria"
					)
				}
			>
				<div className="mr-2 fas fa-download fa-xs" />
				Certidão de Entrega de Ajuda Humanitária
				{hasCertidao ? (
					<div className="ml-2 fas fa-check-circle text-success" />
				) : null}
			</button>
		);
	}

	render = () => {
		const {
			state,
			handleSubmit,
			onChangeDocumento,
			upload,
			handleRichText,
			handleCancelar
		} = this.props;
		return (
			<Fragment>
				<div className="card mt-2">
					<div className="card-body">
						<div className="card-title">
							<Title>Prestação de contas</Title>
							<hr />
						</div>

						<div className="container mb-2">
							<Subtitle>Modelos de documentos</Subtitle>
							<hr />
							<div className="row container">
								{this.modeloAtestado()}
							</div>
							<div className="row container">
								{this.modeloCertidao()}
							</div>
						</div>

						<Formik
							initialValues={state.prestacaoConta}
							enableReinitialize
							onSubmit={handleSubmit}
							render={() => (
								<Form>
									<div className="container mb-1">
										<Subtitle>Documentos</Subtitle>
										<hr />

										<div className="row mb-3">
											<div className="col-md-5">
												<span>
													Selecione o tipo de
													documento a ser submetido:{" "}
													<Required />
												</span>
												<div className="row">
													<div className="col-md-9 mt-2">
														<SelectMulti
															isClearable={false}
															isMulti={false}
															name="tipoDocumento"
															label="property"
															value={
																state.documentoSelecionado
															}
															onChange={item => {
																onChangeDocumento(
																	item,
																	"documentoSelecionado",
																	"tipoDocumento"
																);
															}}
															options={
																this
																	.tiposDocumento
															}
														/>
													</div>
												</div>
											</div>

											{state.documentoSelecionado ? (
												<div className="col-md-7">
													{upload}
												</div>
											) : null}
										</div>
									</div>

									<div className="container">
										<Subtitle>
											Documentos carregados
										</Subtitle>
										<hr />
										<Table
											align="left"
											actions={this.actionsDocumentos}
											columns={this.columnsDocumentos}
											data={
												state.prestacaoConta.documentos
											}
											showPaginate={false}
											emptyMessage="Não há registros cadastrados."
											emptyColSpan={
												this.columnsDocumentos.length +
												1
											}
											permission={[
												PRESTACAO_CONTAS_PERMISSIONS.PRESTAR_CONTAS,
												PRESTACAO_CONTAS_PERMISSIONS.REVISAR
											]}
										/>
									</div>

									<div className="container mb-3">
										<Subtitle>Observações </Subtitle>
										<hr />
										<ReactQuill
											defaultValue={
												state.prestacaoConta.observacoes
											}
											onChange={handleRichText}
										/>
									</div>
									<div className="row mt-3 mb-3">
										<div className="col-12">
											<div className="float-left">
												<Button
													onClick={() =>
														handleCancelar()
													}
													cancel
													type="button"
													text="Cancelar"
													icon="fas fa-times"
												/>
											</div>
											<div className="float-right">
												<Button
													type="submit"
													primary
													text="Finalizar"
													icon="fas fa-check"
												/>
											</div>
										</div>
									</div>
								</Form>
							)}
						/>
					</div>
				</div>
			</Fragment>
		);
	};
}
export default AnalisePrestacao;

AnalisePrestacao.propTypes = {
	upload: PropTypes.node.isRequired,
	onChangeDocumento: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	handleRichText: PropTypes.func.isRequired,
	handleCancelar: PropTypes.func.isRequired,
	downloadFile: PropTypes.func.isRequired,
	state: PropTypes.shape({
		prestacaoConta: PropTypes.shape({
			observacoes: PropTypes.string.isRequired,
			documentos: PropTypes.array.isRequired,
			documentoSelecionado: PropTypes.shape({
				id: PropTypes.number,
				label: PropTypes.string
			})
		}).isRequired
	}).isRequired,
	hasAtestado: PropTypes.bool.isRequired,
	hasCertidao: PropTypes.bool.isRequired
};
